import React from 'react';
import PropTypes from 'prop-types';
import { NumericFormat } from 'react-number-format';

// Wrapping the component with forwardRef to ensure it works correctly with MUI v5
const UIntInputFormatter = React.forwardRef<any, any>((props, ref) => {
  const { onChange, ...other } = props;

  const onValueChange = (values) => {
    onChange({
      target: {
        value: values.value,
      },
    });
  };

  return React.createElement(NumericFormat, {
    ...other,
    getInputRef: ref,
    onValueChange,
    decimalScale: 0,
    allowNegative: false,
  });
});

UIntInputFormatter.displayName = 'UIntInputFormatter';

UIntInputFormatter.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default UIntInputFormatter;
